<template>
  <v-container fluid>
    <card class="pa-4">
      <v-row no-gutters>
        <data-table
          ref="table-hoc"
          :height-offset="252"
          :filters.sync="filters"
          :schema="filterSchema"
          :headers="headers"
          :count="count"
          :loading="loading"
          :items="items"
          @fetch="loadItems"
        >
          <template v-slot:before-filter>
            <v-btn
              depressed
              color="primary"
              outlined
              class="flex-grow-0 mr-4 sv-btn-icon"
              title="Экспорт в CSV"
              @click="exportList"
            >
              <v-icon>mdi-file-excel-outline</v-icon>
            </v-btn>
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template #item.lang_code="{ item }">
            {{
              (
                languageDic.find(entry => entry.id == item.lang_code) || {
                  title: ""
                }
              ).title
            }}
          </template>
        </data-table>
      </v-row>
    </card>
  </v-container>
</template>
<script>
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import QueryMixin from "@/mixins/QueryMixin";

import SearchFilter from "@/components/Filters/SearchFilter";
import SelectFilter from "@/components/Filters/SelectFilter";
import DatetimeRangeFilter from "@/components/Filters/DatetimeRangeFilter";
import DataTable from "@/components/DataTable.vue";

import Repository from "@/api/special/www-subscribers.js";

export default {
  components: { DataTable },
  mixins: [CheckPermissionMixin, QueryMixin],
  data: () => ({
    loading: false,
    filterDialog: false,
    filters: {},
    count: 0,
    items: [],
    languageDic: [
      { id: "ru", title: "Русский" },
      { id: "en", title: "Английский" }
    ],
    exportLoading: false,
    indeterminate: false,
    percent: 0
  }),
  computed: {
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: "Email", value: "email" },
        { text: "Язык", value: "lang_code" },
        { text: "Дата подписки", value: "created_at" }
      ];
    },
    filterSchema() {
      return {
        residentData: {
          filters: {
            id: {
              component: SearchFilter,
              title: "ID",
              filterBind: {
                showMethod: false,
                maxlength: 10,
                rules: "is_integer"
              }
            },
            email: {
              component: SearchFilter,
              title: "Email",
              filterBind: { showMethod: true, maxlength: 50 }
            },
            langCode: {
              component: SelectFilter,
              title: "Язык",
              filterBind: {
                items: this.languageDic,
                valueItem: "id",
                textItem: "title"
              }
            },
            createdAt: {
              component: DatetimeRangeFilter,
              title: "Дата подписки"
            }
          }
        }
      };
    }
  },
  methods: {
    async loadItems(params) {
      try {
        this.loading = true;
        let { data } = await Repository.getList(params);
        this.items = data.items;
        this.count = data.count;
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },
    emitFetch() {
      this.$refs["table-hoc"].fetchData();
    },
    progressCallback({ loaded, total }) {
      this.percent = Math.round((loaded * 100) / total);
      if (this.percent == 100) {
        this.indeterminate = true;
      }
    },
    async exportList() {
      try {
        this.exportLoading = true;
        const options = this.getQueryOptions();
        await Repository.export(options, this.progressCallback);
      } catch (error) {
        return true;
      } finally {
        this.exportLoading = false;
        this.percent = 0;
        this.indeterminate = false;
      }
    }
  }
};
</script>
